import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { IProductionVersionDetailLayout } from '../../../models/layout/production-version-detail-layout.model';
import { ProductionVersionFacade } from '../../../services/facades/external-data/production-version-facade';
import { IProductionVersionState } from '../../../services/facades/external-data/production-version.state.model';
import { ISharedDataState } from '../../../services/facades/master-data/shared-data-state.model';
import { SharedDataFacade } from '../../../services/facades/master-data/shared-data.facade';
import { ProductionVersionLayoutService } from '../../../services/layout/production-version-layout.service';

@Component({
    templateUrl: './production-version-detail.page.html',
    styleUrls: [ './production-version-detail.page.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductionVersionDetailPage implements OnInit, OnDestroy {

    public productionVersionState$: Observable<IProductionVersionState>;
    public sharedDataState$: Observable<ISharedDataState>;
    public layout: IProductionVersionDetailLayout;
    private destroy$: Subject<void> = new Subject();

    constructor(private myProductionVersionFacade: ProductionVersionFacade,
                private myActivatedRoute: ActivatedRoute,
                private mySharedDataFacade: SharedDataFacade,
                private myProductionVersionLayoutService: ProductionVersionLayoutService,
                private myRouter: Router,
                private myLocation: Location) {
    }

    public ngOnInit(): void {
        this.myActivatedRoute.params.pipe(map(params => Number(params[ 'productionVersionId' ])))
            .subscribe((productionVersionId) => {
                void this.myProductionVersionFacade.setSelectedProductionVersion(productionVersionId);
            });

        this.layout = this.myProductionVersionLayoutService.getProductionVersionDetailLayout();
        this.productionVersionState$ = this.myProductionVersionFacade.subState();
        this.sharedDataState$ = this.mySharedDataFacade.subState();

        void Promise.all([
            firstValueFrom(this.mySharedDataFacade.fetchCostUnits()),
            firstValueFrom(this.mySharedDataFacade.fetchArticles()),
            firstValueFrom(this.mySharedDataFacade.fetchMeasureUnits()) ]);

    }

    public ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public goBack(): void {
        this.myLocation.back();
    }

    public navigateToProductionVersion(productionVersionId: number): void {
        void this.myRouter.navigate([ `../${productionVersionId}` ], { relativeTo: this.myActivatedRoute });
    }
}
